<div class="auth-layout">
  <main class="auth-content">
    <div class="auth-inner">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-footer></app-footer>
</div>
